import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { Reveal } from "./Motion";
import { PHONE_TEL, PHONE_DISPLAY, WHATSAPP_URL } from "../data/site";

export const ConversionStrip = () => (
  <section
    data-testid="conversion-strip"
    className="relative bg-[#e60000] overflow-hidden"
  >
    <div className="absolute inset-0 opacity-20 grain" />
    <div className="max-w-[1400px] mx-auto px-4 md:px-10 py-10 md:py-14 flex flex-col lg:flex-row items-center justify-between gap-8 relative z-10">
      <Reveal className="text-center lg:text-left">
        <h2 className="font-display font-bold uppercase text-white text-3xl md:text-4xl lg:text-5xl leading-none tracking-tight">
          Precisa de um guincho agora?
        </h2>
        <p className="mt-3 text-white/90 text-base md:text-lg">
          Atendimento 24 horas em Porto Alegre e região.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
        <a
          data-testid="strip-whatsapp-btn"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full sm:w-auto flex items-center justify-center gap-3 bg-black hover:bg-[#111] text-white px-8 py-5 font-bold uppercase tracking-wide transition-colors"
        >
          <MessageCircle size={22} className="text-[#25D366]" />
          Chamar no WhatsApp
        </a>
        <a
          data-testid="strip-call-btn"
          href={PHONE_TEL}
          className="flex items-center gap-2 text-white font-mono-tech text-xl md:text-2xl font-bold tracking-wide hover:opacity-80 transition-opacity"
        >
          <Phone size={22} />
          {PHONE_DISPLAY}
        </a>
      </Reveal>
    </div>
  </section>
);
